import { ApolloError } from "@apollo/client";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { IProfile } from "./types";
import { GET_CURRENT_USER } from "../../apollo-client/schema/profile/query";
import { ThunkApiConfig } from "../thunkTypes";

export const getProfileThunk = createAsyncThunk<
  IProfile,
  undefined,
  ThunkApiConfig
>(
  "userProfileSlice/getUserProfileThunk",
  async (_, { rejectWithValue, extra }) => {
    try {
      const { data } = await extra.apolloClient.query<{
        userCurrentGet: IProfile;
      }>({
        query: GET_CURRENT_USER,
        fetchPolicy: "network-only",
      });
      return data.userCurrentGet;
    } catch (error) {
      const apolloError = error as ApolloError;
      return rejectWithValue({
        message: apolloError.message || "Unable to load user profile",
      });
    }
  }
);
